import { createSelector } from "@reduxjs/toolkit";
import { SESSION_AUTH_TOKEN } from "../Constants/CommonConstants";

const selectDevtoolsEnabled = (state) =>
  state?.authorization?.jwtTokenValues?.isDevtoolsEnabled;
const selectJwtToken = (state) =>
  state?.authorization?.jwtTokenValues?.jwt ||
  sessionStorage.getItem(SESSION_AUTH_TOKEN);
const selectScopes = (state) => state?.authorization?.jwtTokenValues?.scopes;
const selectFirstName = (state) =>
  state?.authorization?.jwtTokenValues?.firstName;
const selectLastName = (state) =>
  state?.authorization?.jwtTokenValues?.lastName;
const selectUserName = (state) =>
  state?.authorization?.jwtTokenValues?.userName;
const selectHapId = (state) => state?.authorization?.jwtTokenValues?.hapId;
const selectShiftedDateMillisFromEpoch = (state) =>
  state?.authorization?.jwtTokenValues.shiftedDateMillisFromEpoch;
const selectEntitlementList = (state) =>
  state?.authorization?.jwtTokenValues?.entitlementList;
const selectIsEntitledStaff = (state) =>
  state?.authorization?.jwtTokenValues?.isEntitledStaff;

export const manageAuthorizationSelector = createSelector(
  [
    selectDevtoolsEnabled,
    selectJwtToken,
    selectScopes,
    selectFirstName,
    selectLastName,
    selectUserName,
    selectHapId,
    selectShiftedDateMillisFromEpoch,
    selectEntitlementList,
    selectIsEntitledStaff,
  ],
  (
    isDevtoolsEnabled,
    jwtToken,
    scopes,
    firstName,
    lastName,
    userName,
    hapId,
    shiftedDateMillisFromEpoch,
    entitlementList,
    isEntitledStaff
  ) => ({
    isDevtoolsEnabled,
    jwtToken,
    scopes,
    firstName,
    lastName,
    userName,
    hapId,
    shiftedDateMillisFromEpoch,
    entitlementList,
    isEntitledStaff,
  })
);
